import { Component } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import Pagination from "../../../utils/pagination";
import { fill_action } from '../../../actions/fillCombo_action'
import { useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import Card from 'react-bootstrap/Card';
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess, countryActionId, RecommendationTypeActionId, visitorRegistrationLink } from "../../../utils/constants"
import { Link } from "react-router-dom";
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action"
import { getVisitorDashboard_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action"
import { getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/delegate_dashboard_action"
import { getRecommendation_action, getAllRecommendation_action, insertB2bMeeting_action, getRecommendationB2bDetails_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/recommendation_action"
import Modal from "react-modal";
import { getB2bScheduleList_action, removeB2bMeeting_action, updateB2bStatus_action, addB2bPersonalNotes_action } from "../../../actions/delegate_module_action/my_schedule_action/my_schedule_action"
class Recommendation extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States
        this.state = {
            isLoading: false,
            isOpen: false,
            isExhibitionTimeLineBuffer: false,
            isCoordinator: false,
            CoordinatorID: '',
            delegateList: [],
            selectedVisitorID: '',
            isVisitorSelect: false,
            coordinatorFN: '',
            coordinatorLN: '',
            coordinatorDelegateRegistrationID: '',
            b2bID: '',
            page: 'Recommendation',
            typeList: [],
            recommendationList: [],
            allRecommendationList: [],
            countryList: [],
            typeID: 0,
            productRecommendation: '',
            productAll: '',
            countryRecommendation: '',
            countryAll: '',
            companyRecommendation: '',
            companyAll: '',
            fromRegistrationID: '',
            totypeID: '',
            toRegistrationID: ''
        }
        this.getDrawerDetails = this.getDrawerDetails.bind(this)
        this.getRecommendation = this.getRecommendation.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getAllRecommendation = this.getAllRecommendation.bind(this)
        this.handleViewDetails = this.handleViewDetails.bind(this)
        this.handleBook = this.handleBook.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
    }

    // On Component Load
    componentDidMount() {
        const { typeID, typeList } = this.state
        this.getDrawerDetails()
        this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then((res2) => {
            // this.getFillList(RecommendationTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then((res) => {
            //     res.length > 0 && res.map(item => {
            //         console.log(item.TypeName, JSON.parse(sessionStorage.getItem('loginDataSS')).AccountName)
            //         if (item.TypeName == JSON.parse(sessionStorage.getItem('loginDataSS')).AccountName) {
            //             this.setState({ typeID: item.TypeID }, () => {
            // sessionStorage.setItem('typeID', item.TypeID)
            this.getRecommendation().then(() => {
                this.getAllRecommendation()
            })
            //             })
            //         }
            //     })
            // })
        })
        // this.getDelegateCredentials(0).then(res => {
        //     // this.getDeleagateDashboard()

        //     // this.getCoordinatorDelegate()
        // })
    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        // this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                .then((data) => {
                    if (data.error != 1) {
                        // ExhibitionID
                        if (actionID === RecommendationTypeActionId) {
                            console.log("exhibitionStatusActionId", data.data)
                            this.setState({
                                typeList: data.data
                            })
                            resolve(data.data)
                        }
                    }
                    if (actionID === countryActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            countryList: data != null ? data.data : [],
                        })
                        resolve(true)
                    }
                })
        })
    }

    // Get Drawer Details
    getDrawerDetails() {
        this.setState({ isLoading: true })
        this.props.getDrawerDetails_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("Get getDrawerDetails", data.data)
                    const typeID = sessionStorage.getItem('typeID')
                    if (typeID == 1) {
                        sessionStorage.setItem("sessionExhibitorDrawerData", JSON.stringify(data.data))
                    } else {
                        sessionStorage.setItem("sessionVisitorDrawerData", JSON.stringify(data.data))
                    }

                    // Formatting Address
                    var address = data.data[0] != null && data.data[0] != "" && data.data[0]['Address'] != null && data.data[0]['Address'] != "" &&
                        data.data[0]['Address']
                    var addArray = address != "" && address != null && address.split(",")
                    sessionStorage.setItem("FormatedAddress", JSON.stringify(addArray))

                    // Formating Mobile Numbers
                    var mobNo = data.data[0] != null && data.data[0] != "" && data.data[0]['MobileNo'] != null && data.data[0]['MobileNo'] != "" &&
                        data.data[0]['MobileNo']
                    var MobArray = mobNo != "" && mobNo != null && mobNo.split(",")
                    sessionStorage.setItem("FormatedMobNo", JSON.stringify(MobArray))
                    // this.setState({ isLoading: false })
                }
                else {
                    // this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
    }

    getRecommendation() {
        const { typeID, typeList, productRecommendation, companyRecommendation, countryRecommendation, recommendationList } = this.state
        this.setState({ isLoading: true })
        var id = ''
        var type = sessionStorage.getItem('typeID')
        if (type == 1) {
            id = sessionStorage.getItem('ExhRegistrationIDSS')
        } else if (type == 2) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        } else if (type == 3) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
        }
        console.log(companyRecommendation)
        return new Promise((resolve => {
            this.props.getRecommendation_action(id, type, productRecommendation, companyRecommendation, countryRecommendation)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data, 'chapterName')
                        var recommendationdata = []
                        const exhibitionBufferStartTime = data?.data?.[0]?.[0]?.['ExhibitionStartTime'];

                        if (exhibitionBufferStartTime) {
                            const today = new Date();
                            const eventDate = new Date(exhibitionBufferStartTime);
                            const diffTime = eventDate.getTime() - today.getTime();
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                            const isBuffer = diffDays < 21;

                            this.setState({ isExhibitionTimeLineBuffer: isBuffer });
                        }

                        var temprecommendationdatatemp = data.data[0].length > 0 ? data.data[0] : []
                        // if (sessionStorage.getItem('typeID') == 1) {
                        temprecommendationdatatemp = temprecommendationdatatemp.concat(data.data[1].length > 0 ? data.data[1] : [])
                        // }
                        var temprecommendationdata = temprecommendationdatatemp.map(item => {
                            const chapterNames = item.ChapterNames
                                .split(",")
                                .map(name => name.trim())
                                .filter(Boolean);

                            const matchedChapterNames = item.MatchedChapterNames
                                .split(",")
                                .map(name => name.trim())
                                .filter(Boolean);

                            return {
                                ...item,
                                products: chapterNames.map(productName => ({
                                    productName,
                                    isHighLight: matchedChapterNames.includes(productName)
                                }))
                            };
                        });
                        for (var i = 0; i < temprecommendationdata.length; i++) {
                            var obj = {}
                            obj.B2BMeetingID = temprecommendationdata[i].B2BMeetingID
                            obj.CompanyName = temprecommendationdata[i].CompanyName
                            obj.StallName = temprecommendationdata[i].StallName
                            obj.HallName = temprecommendationdata[i].HallName
                            obj.ChapterName = temprecommendationdata[i].ChapterName

                            obj.PersonName = temprecommendationdata[i].PersonName
                            obj.Designation = temprecommendationdata[i].Designation
                            obj.isBookingInitiated = temprecommendationdata[i].isBookingInitiated
                            obj.TypeID = temprecommendationdata[i].TypeID
                            obj.RegistrationID = temprecommendationdata[i].RegistrationID
                            var productArr = temprecommendationdata[i].ChapterNames != null ? temprecommendationdata[i].ChapterNames.split(',') : []
                            var matchArr = temprecommendationdata[i].MatchedChapterNames != null ? temprecommendationdata[i].MatchedChapterNames.split(',') : []
                            // productArr.length > 0 && productArr.map(item => {
                            //     item = item.trim()
                            // })
                            // const finalproductArr = [];
                            // for (var j = 0; j < productArr.length; j++) {
                            //     var current = productArr[j];
                            //     current = current.trim()
                            //     if (/^[0-9]$/.test(current.charAt(0))) {
                            //         finalproductArr.push(current);
                            //         // console.log('current', finalproductArr)
                            //     } else {
                            //         if (finalproductArr.length > 0) {
                            //             finalproductArr[finalproductArr.length - 1] += ` ${current}`;
                            //         } else {
                            //             finalproductArr.push(current);
                            //         }
                            //     }
                            // }

                            // const finalmatchArr = [];
                            // for (var j = 0; j < matchArr.length; j++) {
                            //     var current = matchArr[j];
                            //     current = current.trim()
                            //     if (/^[0-9]$/.test(current.charAt(0))) {
                            //         finalmatchArr.push(current);
                            //     } else {
                            //         if (finalmatchArr.length > 0) {
                            //             finalmatchArr[finalmatchArr.length - 1] += ` ${current}`;
                            //         } else {
                            //             finalmatchArr.push(current);
                            //         }
                            //     }
                            // }

                            // const finalfinalproductArr = [];
                            // for (var j = 0; j < finalproductArr.length; j++) {
                            //     var highlight = false
                            //     for (var k = 0; k < finalmatchArr.length; k++) {
                            //         if (finalproductArr[j] == finalmatchArr[k]) {
                            //             highlight = true
                            //         }
                            //     }
                            //     var obj2 = { 'productName': finalproductArr[j], 'isHighLight': highlight }
                            //     finalfinalproductArr.push(obj2)
                            // }
                            var countryArr = temprecommendationdata[i].CountryName != null ? temprecommendationdata[i].CountryName.split(',') : []
                            obj.data = {
                                'country': countryArr,
                                'products': temprecommendationdata[i].products
                            }
                            recommendationdata.push(obj)
                        }
                        // recommendationdata.length > 0 && recommendationdata.map((item1, in1) => {
                        //     for (var i = 0; i < item1.data.products.length; i++) {
                        //         item1.data.products[i].productName.trim()
                        //         if (/^\d$/.test(item1.data.products[i].productName[0])) {
                        //             for (var j = 0; j < item1.data.products[i].productName.length; j++) {
                        //                 if (item1.data.products[i].productName[j] == ' ') {
                        //                     var str = item1.data.products[i].productName.slice(j)
                        //                     var finalName = str
                        //                     item1.data.products[i].productName = finalName
                        //                     break
                        //                 }
                        //             }
                        //         }
                        //     }
                        // })
                        console.log(recommendationdata, 'lsos')
                        this.setState({ recommendationList: recommendationdata })
                        resolve()
                        // this.setState({ isLoading: false })
                    }
                    else {
                        resolve()
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    clearFilter(mode) {
        const { isLoading, page, countryList, recommendationList, typeID, productRecommendation, productAll, countryRecommendation, countryAll, companyRecommendation, companyAll, allRecommendationList } = this.state
        if (mode == 1) {
            this.setState({
                // companyRecommendation: '',
                // countryRecommendation: '',
                // productRecommendation: '',
                companyAll: '',
                countryAll: '',
                productAll: ''
            }, () => {
                this.getAllRecommendation()
                // this.getRecommendation()
            })
        } else {
            this.setState({
                companyRecommendation: '',
                countryRecommendation: '',
                productRecommendation: '',
                // companyAll:'',
                // countryAll: '',
                // productAll: ''
            }, () => {
                // this.getAllRecommendation()
                this.getRecommendation().then(() => {
                    this.setState({ isLoading: false })
                })
            })
        }

    }

    getAllRecommendation() {
        const { typeID, typeList, productAll, companyAll, countryAll } = this.state
        this.setState({ isLoading: true })
        var id = ''
        var type = sessionStorage.getItem('typeID')
        if (type == 1) {
            id = sessionStorage.getItem('ExhRegistrationIDSS')
        } else if (type == 2) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        } else if (type == 3) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
        }
        console.log(companyAll)

        return new Promise((resolve => {
            this.props.getAllRecommendation_action(id, type, productAll, companyAll, countryAll)
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data)
                        var alldata = []
                        const exhibitionBufferStartTime = data?.data?.[0]?.[0]?.['ExhibitionStartTime'];
                        var recommendationdata = []

                        if (exhibitionBufferStartTime) {
                            const today = new Date();
                            const eventDate = new Date(exhibitionBufferStartTime);
                            const diffTime = eventDate.getTime() - today.getTime();
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                            const isBuffer = diffDays < 21;

                            this.setState({ isExhibitionTimeLineBuffer: isBuffer });
                        }
                        var temprecommendationdatatemp = data.data[0].length > 0 ? data.data[0] : []
                        // if (sessionStorage.getItem('typeID') == 1) {
                        temprecommendationdatatemp = temprecommendationdatatemp.concat(data.data[1].length > 0 ? data.data[1] : [])
                        // }
                        var temprecommendationdata = temprecommendationdatatemp.map(item => {
                            // console.log(item, '--->')
                            const chapterNames = item.ChapterNames != null && item.ChapterNames != '' ? item.ChapterNames
                                .split(",")
                                .map(name => name.trim())
                                .filter(Boolean) : []

                            // const matchedChapterNames = item.MatchedChapterNames
                            //     .split(",")
                            //     .map(name => name.trim())
                            //     .filter(Boolean);

                            return {
                                ...item,
                                products: chapterNames.map(productName => ({
                                    productName,
                                    isHighLight: false
                                }))
                            };
                        });
                        for (var i = 0; i < temprecommendationdata.length; i++) {
                            var obj = {}
                            obj.B2BMeetingID = temprecommendationdata[i].B2BMeetingID
                            obj.CompanyName = temprecommendationdata[i].CompanyName
                            obj.PersonName = temprecommendationdata[i].PersonName
                            obj.Designation = temprecommendationdata[i].Designation
                            obj.StallName = temprecommendationdata[i].StallName
                            obj.HallName = temprecommendationdata[i].HallName
                            obj.ChapterName = temprecommendationdata[i].ChapterName
                            obj.isBookingInitiated = temprecommendationdata[i].isBookingInitiated
                            obj.TypeID = temprecommendationdata[i].TypeID
                            obj.RegistrationID = temprecommendationdata[i].RegistrationID
                            var productArr = temprecommendationdata[i].ChapterNames != null ? temprecommendationdata[i].ChapterNames.split(',') : []
                            var matchArr = temprecommendationdata[i].MatchedChapterNames != null ? temprecommendationdata[i].MatchedChapterNames.split(',') : []

                            // const finalproductArr = [];
                            // for (var j = 0; j < productArr.length; j++) {
                            //     var current = productArr[j];
                            //     current = current.trim()
                            //     if (/^[0-9]$/.test(current.charAt(0))) {
                            //         finalproductArr.push(current);
                            //         // console.log('current', finalproductArr)
                            //     } else {
                            //         if (finalproductArr.length > 0) {
                            //             finalproductArr[finalproductArr.length - 1] += ` ${current}`;
                            //         } else {
                            //             finalproductArr.push(current);
                            //         }
                            //     }
                            // }

                            // const finalmatchArr = [];
                            // for (var j = 0; j < matchArr.length; j++) {
                            //     var current = matchArr[j];
                            //     current = current.trim()
                            //     if (/^[0-9]$/.test(current.charAt(0))) {
                            //         finalmatchArr.push(current);
                            //     } else {
                            //         if (finalmatchArr.length > 0) {
                            //             finalmatchArr[finalmatchArr.length - 1] += ` ${current}`;
                            //         } else {
                            //             finalmatchArr.push(current);
                            //         }
                            //     }
                            // }

                            // const finalfinalproductArr = [];
                            // for (var j = 0; j < finalproductArr.length; j++) {
                            //     var highlight = false
                            //     for (var k = 0; k < finalmatchArr.length; k++) {
                            //         if (finalproductArr[j] == finalmatchArr[k]) {
                            //             highlight = true
                            //         }
                            //     }
                            //     var obj2 = { 'productName': finalproductArr[j], 'isHighLight': highlight }
                            //     finalfinalproductArr.push(obj2)
                            // }
                            // console.log(finalmatchArr, 'finalproductArrfinalproductArr', finalproductArr)
                            var countryArr = temprecommendationdata[i].CountryName != null ? temprecommendationdata[i].CountryName.split(',') : []
                            obj.data = { 'country': countryArr, 'products': temprecommendationdata[i].products }
                            recommendationdata.push(obj)
                        }
                        // console.log(recommendationdata, 'recommendationdata')
                        // recommendationdata.length > 0 && recommendationdata.map((item1, in1) => {
                        //     for (var i = 0; i < item1.data.products.length; i++) {
                        //         item1.data.products[i].productName.trim()
                        //         if (/^\d$/.test(item1.data.products[i].productName[0])) {
                        //             for (var j = 0; j < item1.data.products[i].productName.length; j++) {
                        //                 if (item1.data.products[i].productName[j] == ' ') {
                        //                     var str = item1.data.products[i].productName.slice(j)
                        //                     var finalName = str
                        //                     item1.data.products[i].productName = finalName
                        //                     break
                        //                 }
                        //             }
                        //         }
                        //     }
                        // })
                        console.log(recommendationdata, 'pp')
                        this.setState({ allRecommendationList: recommendationdata })
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }).catch((err) => {
                    console.log(err)
                })
        }))
    }

    handleViewDetails(RegistrationID, TypeID, company, PersonName, Designation, countryList, productList) {
        var id = ''
        var type = sessionStorage.getItem('typeID')
        if (type == 1) {
            id = sessionStorage.getItem('ExhRegistrationIDSS')
        } else if (type == 2) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        } else if (type == 3) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
        }
        // this.props.navigate('/recommendationViewDetails',
        this.setState({
            // typeID: this.state.typeID,
            // fromtypeID: this.state.typeID,
            fromRegistrationID: id,
            totypeID: TypeID,
            toRegistrationID: RegistrationID,
            isOpen: true
            // designation: Designation,
            // countryList: countryList,
            // productList: productList,
            // company: company,
        })

    }

    handleBook(RegistrationID, TypeID, company, PersonName, Designation, countryList, productList) {
        var id = ''
        var type = sessionStorage.getItem('typeID')
        if (type == 1) {
            id = sessionStorage.getItem('ExhRegistrationIDSS')
        } else if (type == 2) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        } else if (type == 3) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
        }
        this.props.navigate('/recommendationBookNow',
            {
                state: {
                    // typeID: this.state.typeID,
                    // fromtypeID: this.state.typeID,
                    fromRegistrationID: id,
                    totypeID: TypeID,
                    toRegistrationID: RegistrationID,
                    isOpen: true
                    // designation: Designation,
                    // countryList: countryList,
                    // productList: productList,
                    // company: company,
                }
            }
        )
    }

    handleKeyPress = (event, status) => {
        if (event.key === 'Enter') {
            if (status == 1) {
                this.getRecommendation().then(() => {
                    this.setState({ isLoading: false })
                })
            } else {
                this.getAllRecommendation()
            }
        }
    };


    insertB2bMeeting() {
        const { remark, dateList, fromRegistrationID, toRegistrationID, totypeID } = this.state
        // var B2bTimeSlotList = []
        // for (var i = 0; i < dateList.length; i++) {
        //     for (var j = 0; j < dateList[i].dateList.length; j++) {
        //         if (dateList[i].dateList[j].isSelect) {
        //             B2bTimeSlotList.push({ 'B2bTimeSlotID': dateList[i].dateList[j].B2BTimeSlotID })
        //         }
        //     }
        // }
        this.setState({ isLoading: true })
        this.props.insertB2bMeeting_action(sessionStorage.getItem('typeID'), fromRegistrationID, totypeID, toRegistrationID, '', [])
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Added to Interested Successfully")
                    // this.setState({ isUpdate: false }, () => {
                    this.getRecommendation().then(() => {
                        this.setState({ b2bID: '' })
                        this.getAllRecommendation()
                    })
                    // this.getB2bDetails()
                    // this.setState({ isLoading: false, isOpen: false })
                    // setTimeout(() => { this.props.navigate('/mySchedule',) }, 1000);
                    // })
                    this.setState({ isOpen: false })
                }
                else {
                    this.setState({ isLoading: false, isOpen: false })
                    // toastError("Meeting has already been booked against this date and time, Please select other timeslot")
                }
            })
    }

    removeMeeting() {
        const { b2bID } = this.state
        this.setState({ isLoading: true })
        this.props.removeB2bMeeting_action(b2bID)
            .then((data) => {
                if (data.error != 1) {
                    setTimeout(() => {
                        this.setState({ b2bID: '', isOpen2: false })
                        this.getRecommendation().then(() => {
                            this.getAllRecommendation()
                        })
                        // this.setState({ isLoading: false, isOpen: false })
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false, isOpen2: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { isLoading, page, isOpen2, isOpen, countryList, isExhibitionTimeLineBuffer, recommendationList, typeID, productRecommendation, productAll, countryRecommendation, countryAll, companyRecommendation, companyAll, allRecommendationList } = this.state
        // if (sessionStorage.getItem('typeID') == 1) {
        var delegateList = []
        var visitorList = []
        var delegateListAll = []
        var visitorListAll = []
        var exhibitorList = []
        var exhibitorListAll = []
        var breakpoint = null
        var breakpointAll = null
        var startpoint = null
        var startpointAll = null
        // for (var i = 0; i < recommendationList.length; i++) {
        //     if (recommendationList[i].TypeID == 3) {
        //         breakpoint = i
        //         break
        //     }
        // }
        // for (var i = 0; i < recommendationList.length; i++) {
        //     if (recommendationList[i].TypeID == 2) {
        //         startpoint = i
        //         break
        //     }
        // }
        // for (var i = 0; i < allRecommendationList.length; i++) {
        //     if (allRecommendationList[i].TypeID == 3) {
        //         breakpointAll = i
        //         break
        //     }
        // }
        // for (var i = 0; i < allRecommendationList.length; i++) {
        //     if (allRecommendationList[i].TypeID == 2) {
        //         startpointAll = i
        //         break
        //     }
        // }
        for (var i = 0; i < allRecommendationList.length; i++) {
            if (allRecommendationList[i].TypeID == 2) {
                delegateListAll.push(allRecommendationList[i])
            } else if (allRecommendationList[i].TypeID == 3) {
                visitorListAll.push(allRecommendationList[i])
            } else if (allRecommendationList[i].TypeID == 1) {
                exhibitorListAll.push(allRecommendationList[i])
            }
        }
        for (var i = 0; i < recommendationList.length; i++) {
            if (recommendationList[i].TypeID == 2) {
                delegateList.push(recommendationList[i])
            } else if (recommendationList[i].TypeID == 3) {
                visitorList.push(recommendationList[i])
            } else if (recommendationList[i].TypeID == 1) {
                exhibitorList.push(recommendationList[i])
            }
        }
        console.log(delegateListAll, 'breakpointAll', this.state.b2bID)
        // }
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />

                {sessionStorage.getItem('RoleIDSS') == 1 ? <ExhibitorHeader /> : (
                    <>
                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorHeader />}
                        {sessionStorage.getItem('typeID') == 2 && <VisitorHeader2 />}
                        {sessionStorage.getItem('typeID') == 3 && <VisitorHeader2 />}
                    </>
                )}

                {sessionStorage.getItem('RoleIDSS') == 1 ? <ExhibitorDrawer /> : (
                    <>
                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorDrawer />}
                        {sessionStorage.getItem('typeID') == 2 && <DelegateDrawer />}
                        {sessionStorage.getItem('typeID') == 3 && <VisitorDrawer />}
                    </>
                )}
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className={sessionStorage.getItem('RoleIDSS') == 1 ? "main-content with-dr-container mt-5" : "main-content with-dr-container mt-3"} style={sessionStorage.getItem('RoleIDSS') == 1 ? { marginTop: '85px' } : {}}>
                            <div className="">
                                <div className="width-dr-nav">
                                    <div className="row">
                                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorTopMenu />}
                                        {sessionStorage.getItem('typeID') == 2 && <DelegateTopMenu />}
                                        {sessionStorage.getItem('typeID') == 3 && <VisitorTopMenu />}
                                    </div>
                                </div>
                                <div className="border-bottom my-3 mx-0 mx-md-3 text-left d-flex flex-nowrap overflow-auto" style={{ whiteSpace: 'nowrap', paddingBottom: '2px' }}>
                                    <div className="tab-recommendation flex-shrink-0" style={{ backgroundColor: page == 'Recommendation' ? '#3dbca7db' : '', color: page == 'Recommendation' ? '#fff' : '' }} onClick={() => this.setState({ page: 'Recommendation' })}>AI Recommendate Matching </div>
                                    <div className="tab-recommendation flex-shrink-0 ms-2" style={{ backgroundColor: page == 'All' ? '#3dbca7db' : '', color: page == 'All' ? '#fff' : '' }} onClick={() => this.setState({ page: 'All' })}>All Exhibitors</div>
                                </div>
                                {/* //////////////////////Recommendation */}
                                {page == 'Recommendation' && <div class="tab-content pt-1 m-2" >
                                    <div className="row mb-3 m-0">
                                        <div className="col-xl-4">
                                            <label>Company</label>
                                            <input value={companyRecommendation} type="text" className="form-control" onKeyDown={(e) => this.handleKeyPress(e, 1)} onChange={(e) => this.setState({ companyRecommendation: e.target.value })} />
                                        </div>
                                        <div className="col-xl-4">
                                            <label>Search by Country</label>
                                            <input value={countryRecommendation} type="text" className="form-control" onKeyDown={(e) => this.handleKeyPress(e, 1)} onChange={(e) => this.setState({ countryRecommendation: e.target.value })} />
                                        </div>
                                        <div className="col-xl-4">
                                            <label>Search by Product/Character/Keywords</label>
                                            <input type="text" className="form-control" value={productRecommendation} onKeyDown={(e) => this.handleKeyPress(e, 1)} onChange={(e) => this.setState({ productRecommendation: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="row mb-3 m-0">
                                        <div className="col-12 text-right text-end">
                                            <button type="button" className="btn btn-gray mx-2" onClick={() => this.clearFilter()}>Clear</button>
                                            <button type="button" className="btn btn-aqua " onClick={() => this.getRecommendation().then(() => {
                                                this.setState({ isLoading: false })
                                            })}>Search</button>
                                        </div>
                                    </div>
                                    {
                                        // sessionStorage.getItem('typeID') == 1 ?
                                        <Accordion >
                                            {/* {sessionStorage.getItem('typeID') != 1 && <Card style={{ margin: '2px' }}>
                                                <Card.Header style={{ padding: 0, margin: 0 }}>
                                                    <CustomToggle type="1" eventKey="1"></CustomToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="1"> */}
                                            <Card.Body className="pe-0 pt-0">
                                                {exhibitorList.length > 0 ? exhibitorList.map((data, i) => (
                                                    // data.isBookingInitiated != 1 &&
                                                    <div class="card border p-0 mt-1">

                                                        <h6 class="card-header bg-light p-3" style={{ justifyContent: 'left' }}><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                        <div class="card-right-btn-recommendation mt-2">
                                                            <button type="button" class="btn btn-aqua "
                                                                disabled={isExhibitionTimeLineBuffer} onClick={() => data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleViewDetails(data.RegistrationID, data.TypeID)}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>
                                                            {/* <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-gray p-1 px-2 px-4 ms-2" onClick={() => {
                                                                        if (isExhibitionTimeLineBuffer == false) {
                                                                            this.handleBook(data.RegistrationID, data.TypeID)
                                                                            return
                                                                        }
                                                                    }}>Book</button> */}
                                                            {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                                        </div>
                                                        <div className="card-body p-4 pb-2">
                                                            <div className="row mb-0 text-left">
                                                                <div className="col-md-4 mb-3 mb-md-0">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Location</p>

                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '14px', color: '#222', marginTop: '2px' }}>
                                                                        Hall Name: {data.HallName ? 'Hall ' + String(data.HallName).replace(/hall\s*(name|no\.?|:)?\s*/i, '').trim() : '-'} &nbsp;&nbsp;&nbsp;&nbsp; Stall No: {data.StallName ? String(data.StallName).replace(/stall\s*(name|no\.?|:)?\s*/i, '').trim() : '-'}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-4 mb-3 mb-md-0">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Main Segment</p>
                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>{data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}</p>
                                                                </div>
                                                                <div className="col-md-4 mb-3 mb-md-0">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Country</p>
                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>
                                                                        {data.data.country.length > 0 ? data.data.country.join(', ') : '-'}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            {data.data.products.length > 0 && (
                                                                <div className="mt-3 text-left">
                                                                    <style>{`
                                                                        @media (max-width: 767px) {
                                                                            .mobile-badge-full {
                                                                                width: 100% !important;
                                                                                display: block !important;
                                                                            }
                                                                        }
                                                                    `}</style>
                                                                    <div className="d-flex flex-wrap" style={{ marginLeft: '-4px' }}>
                                                                        {data.data.products.map((item, index) => (
                                                                            <span key={index} className="badge border p-2 px-3 mr-2 mb-2 m-1 mobile-badge-full" style={{ color: item.isHighLight ? '#3dbca7' : '#222', fontWeight: 'normal', fontSize: '14px', borderColor: '#d5e9e6', whiteSpace: 'normal', textAlign: 'left', backgroundColor: item.isHighLight ? 'rgba(61, 188, 167, 0.1)' : 'white' }}>{item.productName}</span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )) : (
                                                    <div class="card border p-0 mt-1">
                                                        <h6 class="card-header bg-light p-3" style={{ justifyContent: 'center' }}>Not found any matching recommendation</h6>
                                                    </div>
                                                )
                                                }
                                            </Card.Body>
                                            {/* </Accordion.Collapse>
                                            </Card>} */}
                                            {sessionStorage.getItem('typeID') != 2 && false && <Card style={{ margin: '2px' }}>
                                                <Card.Header style={{ padding: 0, margin: 0 }}>
                                                    <CustomToggle type="2" eventKey="2"></CustomToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        {delegateList.length > 0 ? delegateList.map((data, i) => (
                                                            // data.isBookingInitiated != 1 &&
                                                            <div class="card border p-0 mt-1">
                                                                {console.log(data, 'card')}
                                                                <h6 class="card-header bg-light p-3" style={{ justifyContent: 'left' }}><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                                <div class="card-right-btn-recommendation mt-2">
                                                                    {sessionStorage.getItem('typeID') != 3 ? <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-aqua" onClick={() => data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleViewDetails(data.RegistrationID, data.TypeID)}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>
                                                                        : <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-gray p-1 px-2 px-4 ms-2" onClick={() => {
                                                                            if (isExhibitionTimeLineBuffer == false) {
                                                                                data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleBook(data.RegistrationID, data.TypeID)
                                                                                return
                                                                            }
                                                                        }}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>}
                                                                    {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                                                </div>
                                                                <div class="card-body p-3">
                                                                    {data.data.country.length > 0 && data.data.country.map(item => (
                                                                        <h6 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker" style={{ color: '#9ea0a1' }}></i> &nbsp; {item} </h6>
                                                                    ))}
                                                                    {data.data.products.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                                                        <ul>
                                                                            {data.data.products.map(item => (
                                                                                <li style={{ backgroundColor: item.isHighLight ? '#3dbca7db' : 'none' }}>{item.productName}</li>))}
                                                                        </ul>
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                        )) : (
                                                            <div class="card border p-0 mt-1">
                                                                <h6 class="card-header bg-light p-3" style={{ justifyContent: 'center' }}>Not found any matching recommendation</h6>
                                                            </div>
                                                        )
                                                        }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>}
                                            {sessionStorage.getItem('typeID') != 3 && false && <Card style={{ margin: '2px' }}>
                                                <Card.Header style={{ padding: 0, margin: 0 }}>
                                                    <CustomToggle type="3" eventKey="3"></CustomToggle>
                                                </Card.Header>
                                                <Accordion.Collapse eventKey="3">
                                                    <Card.Body>
                                                        {
                                                            visitorList.length > 0 ? visitorList.map((data, i) => (
                                                                // data.isBookingInitiated != 1 &&
                                                                <div class="card border p-0 mt-1">

                                                                    <h6 class="card-header bg-light p-3" style={{ justifyContent: 'left' }}><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                                    <div class="card-right-btn-recommendation mt-2">
                                                                        <button type="button" class="btn btn-aqua" disabled={isExhibitionTimeLineBuffer} onClick={() => data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleViewDetails(data.RegistrationID, data.TypeID)}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>
                                                                        {/* <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-aqua px-4 ms-2" onClick={() => {
                                                                            if (isExhibitionTimeLineBuffer == false) {
                                                                                this.handleBook(data.RegistrationID, data.TypeID)
                                                                                return
                                                                            }
                                                                        }}>Book</button> */}
                                                                        {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                                                    </div>
                                                                    <div class="card-body p-3">
                                                                        {data.data.country.length > 0 && data.data.country.map(item => (
                                                                            <h6 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker" style={{ color: '#9ea0a1' }}></i> &nbsp; {item} </h6>
                                                                        ))}
                                                                        {data.data.products.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                                                            <ul>
                                                                                {data.data.products.map(item => (
                                                                                    <li style={{ backgroundColor: item.isHighLight ? '#3dbca7db' : 'none' }}>{item.productName}</li>))}
                                                                            </ul>
                                                                        </div>}
                                                                    </div>
                                                                </div>
                                                            )) : (
                                                                <div class="card border p-0 mt-1">
                                                                    <h6 class="card-header bg-light p-3" style={{ justifyContent: 'center' }}>Not found any matching recommendation</h6>
                                                                </div>
                                                            )
                                                        }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>}
                                        </Accordion>
                                        //  : recommendationList.length > 0 ? recommendationList.map((data, i) => (
                                        //     data.isBookingInitiated != 1 &&
                                        //     <div class="card border p-0 mt-1">

                                        //         <h6 class="card-header bg-light p-3"><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                        //         <div class="card-right-btn-recommendation mt-2">
                                        //             <button type="button" class="btn  btn-aqua p-1 px-2" onClick={() => this.handleViewDetails(data.RegistrationID, data.TypeID)}>View Details</button>
                                        //             {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                        //         </div>
                                        //         <div class="card-body p-3">
                                        //             {data.data.country.length > 0 && data.data.country.map(item => (
                                        //                 <h6 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker" style={{ color: '#9ea0a1' }}></i> &nbsp; {item} </h6>
                                        //             ))}
                                        //             {data.data.products.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                        //                 <ul>
                                        //                     {data.data.products.map(item => (
                                        //                         <li style={{ backgroundColor: item.isHighLight ? '#3dbca7db' : 'none' }}>{item.productName}</li>))}
                                        //                 </ul>
                                        //             </div>}
                                        //         </div>
                                        //     </div>
                                        // ))
                                        //  : (
                                        //     <div class="card border p-0 mt-1">
                                        //         <h6 class="card-header bg-light p-3">NA</h6>
                                        //     </div>
                                        // )
                                    }
                                </div>}
                                {/* //////////////////////All */}
                                {page == 'All' && <div class="tab-content pt-1 m-2" >
                                    <div className="row mb-3 m-0">
                                        <div className="col-xl-4">
                                            <label>Company</label>
                                            <input value={companyAll} type="text" className="form-control" onKeyDown={(e) => this.handleKeyPress(e)} onChange={(e) => this.setState({ companyAll: e.target.value })} />
                                        </div>
                                        <div className="col-xl-4">
                                            <label>Search by Country</label>
                                            <input value={countryAll} type="text" className="form-control" onKeyDown={(e) => this.handleKeyPress(e)} onChange={(e) => this.setState({ countryAll: e.target.value })} />
                                        </div>
                                        <div className="col-xl-4">
                                            <label>Search by Product/Character/Keywords</label>  
                                            <input type="text" className="form-control" value={productAll} onKeyDown={(e) => this.handleKeyPress(e)} onChange={(e) => this.setState({ productAll: e.target.value })} />
                                        </div>
                                    </div>
                                    <div className="row mb-1 m-0">
                                        <div className="col-12 text-right text-end">
                                            <button type="button" className="btn btn-gray mx-2" onClick={() => this.clearFilter(1)}>Clear</button>
                                            <button type="button" className="btn btn-aqua" onClick={() => this.getAllRecommendation()}>Search</button>
                                        </div>
                                    </div>
                                    {/* {sessionStorage.getItem('typeID') == 1 ? */}
                                    <Accordion >
                                        {/* {sessionStorage.getItem('typeID') != 1 && <Card style={{ margin: '2px' }}>
                                            <Card.Header style={{ padding: 0, margin: 0 }}>
                                                <CustomToggle type="1" eventKey="1"></CustomToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="1"> */}
                                        <Card.Body className="pe-0 pt-0">
                                            {
                                                exhibitorListAll.length > 0 && exhibitorListAll.map((data, i) => (
                                                    // data.isBookingInitiated != 1 &&
                                                    <div class="card border p-0 mt-1">
                                                        <h6 class="card-header bg-light p-3" style={{ justifyContent: 'left' }}><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                        <div class="card-right-btn-recommendation mt-2">
                                                            <button type="button" class="btn btn-aqua" disabled={isExhibitionTimeLineBuffer} onClick={() => data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleViewDetails(data.RegistrationID, data.TypeID)}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>
                                                            {/* <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-gray p-1 px-2 px-4 ms-2" onClick={() => {
                                                                        if (isExhibitionTimeLineBuffer == false) {
                                                                            this.handleBook(data.RegistrationID, data.TypeID)
                                                                            return
                                                                        }
                                                                    }}>Book</button> */}
                                                            {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                                        </div>
                                                        <div className="card-body p-4 pb-2">
                                                            <div className="row mb-0 text-left">
                                                                <div className="col-md-4 mb-3 mb-md-0">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Location</p>

                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '14px', color: '#222', marginTop: '2px' }}>
                                                                        Hall Name: {data.HallName ? 'Hall ' + String(data.HallName).replace(/hall\s*(name|no\.?|:)?\s*/i, '').trim() : '-'} &nbsp;&nbsp;&nbsp;&nbsp; Stall No: {data.StallName ? String(data.StallName).replace(/stall\s*(name|no\.?|:)?\s*/i, '').trim() : '-'}
                                                                    </p>
                                                                </div>
                                                                <div className="col-md-4 mb-3 mb-md-0">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Main Segment</p>
                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>{data.ChapterName != '' && data.ChapterName != null ? data.ChapterName : '-'}</p>
                                                                </div>
                                                                <div className="col-md-4 mb-3 mb-md-0">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Country</p>
                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>
                                                                        {data.data.country.length > 0 ? data.data.country.join(', ') : '-'}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            {data.data.products.length > 0 && (
                                                                <div className="mt-3 text-left">
                                                                    <style>{`
                                                                        @media (max-width: 767px) {
                                                                            .mobile-badge-full {
                                                                                width: 100% !important;
                                                                                display: block !important;
                                                                            }
                                                                        }
                                                                    `}</style>
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Products</p>
                                                                    <div className="d-flex flex-wrap" style={{ marginLeft: '-4px' }}>
                                                                        {data.data.products.map((item, index) => (
                                                                            <span key={index} className="badge border p-2 px-3 mr-2 mb-2 m-1 mobile-badge-full" style={{ color: item.isHighLight ? '#3dbca7' : '#222', fontWeight: 'normal', fontSize: '14px', borderColor: '#d5e9e6', whiteSpace: 'normal', textAlign: 'left', backgroundColor: item.isHighLight ? 'rgba(61, 188, 167, 0.1)' : 'white' }}>{item.productName}</span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </Card.Body>
                                        {/* </Accordion.Collapse>
                                        </Card>} */}
                                        {sessionStorage.getItem('typeID') != 2 && false && <Card style={{ margin: '2px' }}>
                                            <Card.Header style={{ padding: 0, margin: 0 }}>
                                                <CustomToggle type="2" eventKey="2"></CustomToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="2">
                                                <Card.Body>
                                                    {
                                                        delegateListAll.length > 0 && delegateListAll.map((data, i) => (
                                                            data.isBookingInitiated != 1 &&
                                                            <div class="card border p-0 mt-1">
                                                                <h6 class="card-header bg-light p-3" style={{ justifyContent: 'left' }}><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                                <div class="card-right-btn-recommendation mt-2">
                                                                    {sessionStorage.getItem('typeID') != 3 ? <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-aqua" onClick={() => data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleViewDetails(data.RegistrationID, data.TypeID)}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>
                                                                        : <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-gray p-1 px-2 px-4 ms-2" onClick={() => {
                                                                            if (isExhibitionTimeLineBuffer == false) {
                                                                                data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleBook(data.RegistrationID, data.TypeID)
                                                                                return
                                                                            }
                                                                        }}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>}
                                                                    {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                                                </div>
                                                                <div class="card-body p-3">
                                                                    {data.data.country.length > 0 && data.data.country.map(item => (
                                                                        <h6 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker" style={{ color: '#9ea0a1' }}></i> &nbsp; {item} </h6>
                                                                    ))}
                                                                    {data.data.products.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                                                        <ul>
                                                                            {data.data.products.map(item => (
                                                                                <li style={{ backgroundColor: item.isHighLight ? '#3dbca7db' : 'none' }}>{item.productName}</li>))}
                                                                        </ul>
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>}
                                        {sessionStorage.getItem('typeID') != 3 && false && <Card style={{ margin: '2px' }}>
                                            <Card.Header style={{ padding: 0, margin: 0 }}>
                                                <CustomToggle type="3" eventKey="3"></CustomToggle>
                                            </Card.Header>
                                            <Accordion.Collapse eventKey="3">
                                                <Card.Body>
                                                    {
                                                        visitorListAll.length > 0 && visitorListAll.map((data, i) => (
                                                            data.isBookingInitiated != 1 &&
                                                            <div class="card border p-0 mt-1">
                                                                <h6 class="card-header bg-light p-3" style={{ justifyContent: 'left' }}><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                                <div class="card-right-btn-recommendation mt-2">
                                                                    <button type="button" class="btn btn-aqua" disabled={isExhibitionTimeLineBuffer} onClick={() => data.isBookingInitiated ? this.setState({ isOpen2: true, b2bID: data.B2BMeetingID }) : this.handleViewDetails(data.RegistrationID, data.TypeID)}>{data.isBookingInitiated ? "Not Interested" : 'Interested to meet'}</button>
                                                                    {/* <button type="button" disabled={isExhibitionTimeLineBuffer} class="btn btn-aqua px-4 ms-2" onClick={() => {
                                                                            if (isExhibitionTimeLineBuffer == false) {
                                                                                this.handleBook(data.RegistrationID, data.TypeID)
                                                                                return
                                                                            }
                                                                        }}>Book</button> */}
                                                                    {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}
                                                                </div>
                                                                <div class="card-body p-3">
                                                                    {data.data.country.length > 0 && data.data.country.map(item => (
                                                                        <h6 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker" style={{ color: '#9ea0a1' }}></i> &nbsp; {item} </h6>
                                                                    ))}
                                                                    {data.data.products.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                                                        <ul>
                                                                            {data.data.products.map(item => (
                                                                                <li style={{ backgroundColor: item.isHighLight ? '#3dbca7db' : 'none' }}>{item.productName}</li>))}
                                                                        </ul>
                                                                    </div>}
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>}
                                    </Accordion>
                                    {/* :
                                        allRecommendationList.length > 0 && allRecommendationList.map((data, i) => (
                                            data.isBookingInitiated != 1 &&
                                            <div class="card border p-0 mt-1">
                                                <h6 class="card-header bg-light p-3"><i class="fa fa-building-o" style={{ color: '#9ea0a1' }}></i>&nbsp; {data.CompanyName}</h6>
                                                <div class="card-right-btn-recommendation mt-2">
                                                    <button type="button" class="btn  btn-aqua p-1 px-2" onClick={() => this.handleViewDetails(data.RegistrationID, data.TypeID)}>View Details</button>
                                                    {isExhibitionTimeLineBuffer ? <span>Less than 21 days remaining until the event begins.</span> : <></>}

                                                </div>
                                                <div class="card-body p-3">
                                                    {data.data.country.length > 0 && data.data.country.map(item => (
                                                        <h6 class="card-title mb-2 pb-2 border-bottom text-left"><i class="fa fa-map-marker" style={{ color: '#9ea0a1' }}></i> &nbsp; {item} </h6>
                                                    ))}
                                                    {data.data.products.length > 0 && <div class="product-list-recommendation" style={{ marginLeft: '-35px' }}>
                                                        <ul>
                                                            {data.data.products.map(item => (
                                                                <li>{item}</li>))}
                                                        </ul>
                                                    </div>}
                                                </div>
                                            </div>
                                        ))
                                    } */}
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
                        <div className="modal-content border-0" style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', margin: 'auto', backgroundColor: '#fff', overflow: 'hidden' }}>
                            <div className="modal-header border-0 pb-0" style={{ padding: '24px 24px 10px 24px', backgroundColor: '#fff' }}>
                                <h5 className="modal-title" style={{ color: '#00665c', fontWeight: 'bold', fontSize: '18px' }}>Interested to meet</h5>
                                <button type="button" className="close" onClick={() => this.setState({ isOpen: false })} style={{ opacity: 1, backgroundColor: 'transparent', border: 'none', fontSize: '24px', outline: 'none', cursor: 'pointer', color: '#333' }}>&times;</button>
                            </div>
                            <div className="modal-body" style={{ padding: '16px 24px 24px 24px', backgroundColor: '#fff' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ fontSize: '16px', color: '#333', lineHeight: '1.5' }}>
                                        Do you really want to add this exhibitor in your interest list?
                                    </div>
                                </div>
                            </div>
                            <div style={{ borderTop: '1px solid #eee', margin: '0 24px' }}></div>
                            <div className="modal-footer border-0 flex-column" style={{ padding: '24px', backgroundColor: '#fff' }}>
                                <button type="button" className="btn btn-aqua w-100 mb-3" onClick={(e) => this.insertB2bMeeting(e)}>Yes</button>
                                <button type="button" className="btn btn-gray w-100 m-0" onClick={() => this.setState({ isOpen: false })}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isOpen2} onRequestClose={() => this.setState({ isOpen2: false })}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
                        <div className="modal-content border-0" style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', margin: 'auto', backgroundColor: '#fff', overflow: 'hidden' }}>
                            <div className="modal-header border-0 pb-0" style={{ padding: '24px 24px 10px 24px', backgroundColor: '#fff' }}>
                                <h5 className="modal-title" style={{ color: '#00665c', fontWeight: 'bold', fontSize: '18px' }}>Interested to meet</h5>
                                <button type="button" className="close" onClick={() => this.setState({ isOpen2: false })} style={{ opacity: 1, backgroundColor: 'transparent', border: 'none', fontSize: '24px', outline: 'none', cursor: 'pointer', color: '#333' }}>&times;</button>
                            </div>
                            <div className="modal-body" style={{ padding: '16px 24px 24px 24px', backgroundColor: '#fff' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ fontSize: '16px', color: '#333', lineHeight: '1.5' }}>
                                        Do you really want to remove this exhibitor from your interest list?
                                    </div>
                                </div>
                            </div>
                            <div style={{ borderTop: '1px solid #eee', margin: '0 24px' }}></div>
                            <div className="modal-footer border-0 flex-column" style={{ padding: '24px', backgroundColor: '#fff' }}>
                                <button type="button" className="btn btn-aqua w-100 mb-3" onClick={(e) => this.removeMeeting()}>Yes</button>
                                <button type="button" className="btn btn-gray w-100 m-0" onClick={() => this.setState({ isOpen2: false })}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>)
    }
}


function CustomToggle({ children, eventKey, type }) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, () =>
        console.log('totally custom!', type),
    );
    const isCurrentEventKey = activeEventKey === eventKey
    return (
        <div onClick={decoratedOnClick} style={{ width: '100%', textAlign: 'left', backgroundColor: '#ECECEC' }}
        >
            <h6 style={{ padding: '15px 20px' }}>
                {type == 2 ? 'Delegate Listing' : type == 1 ? "Exhibitor Listing" : 'Visitor Listing'}
            </h6>
        </div>
    );
}

export default withRouter(connect(null, { getDrawerDetails_action, getRecommendation_action, fill_action, getVisitorDashboard_action, getCoordinatorDelegate_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action, insertB2bMeeting_action, getCoordinatorDelegate_action, removeB2bMeeting_action, getRecommendationB2bDetails_action, getAllRecommendation_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action })(Recommendation))

